<div class="inner-container">
  @if (isloading) {
    <mat-progress-bar
      mode="indeterminate" value="80" class="mb-15">
    </mat-progress-bar>
  } @else {
    <div class="btn-group">
      <button mat-raised-button (click)="handleEditUserDialog(selectedRow)" [disabled]="!selectedRow" color="primary" class="primary-btn mb-15">
        Edit User
      </button>
      <button mat-flat-button (click)="handleAddNewUserDialog()" color="primary" class="primary-btn mb-15">
        New User
      </button>
      <button mat-raised-button (click)="handleDeleteUserDialog()" [disabled]="!selectedRow" color="primary" class="primary-btn mb-15">
        Delete User
      </button>
    </div>

    <table mat-table [dataSource]="dataSource" matSort>
       <!-- Username Column -->
      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Username </th>
        <td mat-cell *matCellDef="let element"> {{element.username}} </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email_address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email Address </th>
        <td mat-cell *matCellDef="let element"> {{element.email_address}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="last_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let element"> {{element.first_name}} {{element.last_name}}</td>
      </ng-container>

      <!-- IsAdmin Column -->
      <ng-container matColumnDef="tenant_admin">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Admin </th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle class="mat-accent" [checked]=" element.tenant_admin"
            [disabled]="isCurrentUser(element) || isloading" (change)="onAdminToggle(element, $event.checked)"></mat-slide-toggle>
        </td>
      </ng-container>

      <tr class="header-shadow" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        (click)="setSelected(row)"
        [ngClass]="{ selectedRow: selectedRow === row.user_id}">
      </tr>
      </table>
    }
</div>
